"use strict";
exports.addBusinessDays = addBusinessDays;
var _index = require("./constructFrom.js");
var _index2 = require("./isSaturday.js");
var _index3 = require("./isSunday.js");
var _index4 = require("./isWeekend.js");
var _index5 = require("./toDate.js");
function addBusinessDays(date, amount) {
  const _date = (0, _index5.toDate)(date);
  const startedOnWeekend = (0, _index4.isWeekend)(_date);
  if (isNaN(amount)) return (0, _index.constructFrom)(date, NaN);
  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);
  _date.setDate(_date.getDate() + fullWeeks * 7);
  let restDays = Math.abs(amount % 5);
  while (restDays > 0) {
    _date.setDate(_date.getDate() + sign);
    if (!(0, _index4.isWeekend)(_date)) restDays -= 1;
  }
  if (startedOnWeekend && (0, _index4.isWeekend)(_date) && amount !== 0) {
    if ((0, _index2.isSaturday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
    if ((0, _index3.isSunday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
  }
  _date.setHours(hours);
  return _date;
}
